// extracted by mini-css-extract-plugin
export default {"wrapper":"TestimonialSection_wrapper__k-saH","swiperNav":"TestimonialSection_swiperNav__yV6sT","prev":"TestimonialSection_prev__u4bfw","next":"TestimonialSection_next__PvSbA"};